import './renton/style';
import FormStructure from './renton/form_structure';

export default FormStructure;